export default {"src":"/_next/static/media/square-dark.4da116c7.svg","height":386,"width":386,"blurWidth":0,"blurHeight":0};